/*
 * Home button with Latitude logo
 */
import * as React from 'react';
import classnames from 'classnames';
import { Link } from '@latitude/link';
import SvgInline from '@latitude/svg-inline';
import './_home-button.scss';

var HomeButton = function HomeButton(props) {
  var className = props.className,
      mobileVisible = props.mobileVisible;
  return /*#__PURE__*/React.createElement(Link, {
    noStyle: true,
    href: "https://www.latitudefinancial.com.au/",
    className: classnames('home-button', className, {
      'mobile-visible': mobileVisible
    }),
    trackId: "nav-lfs-home",
    trackEventData: {
      label: 'Latitude'
    }
  }, /*#__PURE__*/React.createElement(SvgInline, {
    name: "logo-combination",
    "aria-label": "Home page",
    className: "home-button__logo",
    fillBlueBright: true
  }));
};

export default HomeButton;